import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight, Award, GraduationCap } from "lucide-react";
import { api } from "@/lib/api";
import { imgUrl } from "@/lib/api";
import { SectionHeader } from "@/pages/Home";

const initials = (n) => n.split(" ").map((w) => w[0]).slice(0, 2).join("").toUpperCase();

export default function Docenti() {
  const [DOCENTI, setDocenti] = React.useState([]);
  React.useEffect(() => { api.get("/teachers").then((r) => setDocenti(r.data)).catch(console.error); }, []);
  return (
    <div className="bg-white">
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 sm:pt-24 pb-6">
        <SectionHeader eyebrow="Il nostro team" title="Docenti e formatori" subtitle="Professionisti qualificati che uniscono competenza tecnica ed esperienza sul campo, per una formazione concreta ed efficace." />
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-20 sm:pb-28">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8" data-testid="docenti-grid">
          {DOCENTI.map((d, i) => (
            <motion.div key={d.id} initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-40px" }} transition={{ duration: 0.45, delay: (i % 3) * 0.06 }}>
              <Link to={`/docenti/${d.id}`} data-testid={`docente-card-${d.id}`}
                className="group block bg-white rounded-3xl border border-gray-100 overflow-hidden transition-all duration-300 hover:-translate-y-1.5 hover:shadow-[0_20px_40px_rgba(0,0,0,0.08)]">
                <div className="relative h-64 overflow-hidden bg-gray-100">
                  {d.photo ? (
                    <img src={imgUrl(d.photo)} alt={d.name} loading="lazy" className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105" />
                  ) : (
                    <div className="w-full h-full flex items-center justify-center" style={{ background: "linear-gradient(135deg,#EA6A0A 0%,#F59E42 100%)" }}>
                      <span className="font-display font-800 text-6xl text-white/95">{initials(d.name)}</span>
                    </div>
                  )}
                </div>
                <div className="p-6">
                  <h3 className="font-display font-700 text-lg text-[#111827] tracking-tight group-hover:text-[#EA6A0A] transition-colors">{d.name}</h3>
                  <p className="text-sm font-600 text-[#2FA84F] mt-0.5">{d.role}</p>
                  <div className="mt-3 flex flex-wrap gap-1.5">
                    {d.specializzazioni.slice(0, 3).map((s) => (
                      <span key={s} className="text-[11px] font-600 px-2.5 py-1 rounded-full bg-[#EA6A0A]/5 text-[#EA6A0A]">{s}</span>
                    ))}
                  </div>
                  <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-600 text-[#EA6A0A] group-hover:gap-2.5 transition-all">Profilo completo <ArrowUpRight size={16} /></span>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </section>
    </div>
  );
}
